import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoggedIn, setUserInfo2 } from "../reduxToolkit/redux";
import { useNavigate } from 'react-router-dom';
import { FaComments } from 'react-icons/fa';
import fnc from '../mymod/commFunction';

function KakaoLogin({ loading, setLoading }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const initKakao = () => {
            if (window.Kakao && window.Kakao.isInitialized()) {
                try {
                    window.Kakao.cleanup();
                } catch (e) {
                    // cleanup 무시
                }
            }
            
            if (window.Kakao && !window.Kakao.isInitialized()) {
                try {
                    window.Kakao.init('ac578e1ca34885c6098e9efca4fa2312');
                } catch (error) {
                    alert('카카오 SDK 초기화에 실패했습니다.');
                }
            }
        };

        if (!window.Kakao) {
            const kakaoScript = document.createElement('script');
            kakaoScript.src = 'https://developers.kakao.com/sdk/js/kakao.js';
            kakaoScript.onload = initKakao;
            kakaoScript.onerror = () => {
                alert('카카오 서비스를 이용할 수 없습니다.');
            };
            document.head.appendChild(kakaoScript);
        } else {
            initKakao();
        }
    }, []);

    const handleKakaoLogin = async () => {
        setLoading(true);
        try {
            if (!window.Kakao || !window.Kakao.isInitialized()) {
                alert('카카오 SDK가 초기화되지 않았습니다. 페이지를 새로고침 후 다시 시도해주세요.');
                setLoading(false);
                return;
            }



            window.Kakao.Auth.login({
                scope: 'profile_nickname,profile_image,account_email,phone_number,name,age_range,birthday,birthyear,gender',
                throughTalk: false,
                success: async (authObj) => {
                    
                    window.Kakao.API.request({
                        url: '/v2/user/me',
                        data: {
                            property_keys: [
                                'properties.nickname',
                                'properties.profile_image',
                                'properties.thumbnail_image',
                                'kakao_account.email',
                                'kakao_account.phone_number',
                                'kakao_account.age_range',
                                'kakao_account.birthday',
                                'kakao_account.birthyear',
                                'kakao_account.gender',
                                'kakao_account.name',
                                'kakao_account.email_needs_agreement',
                                'kakao_account.phone_number_needs_agreement',
                                'kakao_account.profile_needs_agreement'
                            ]
                        },
                        success: (res) => {        
                            const { id, properties, kakao_account } = res;
                            console.log(res, '======= kaka res');
                            
                            const missingInfo = [];
                            if (!kakao_account?.email) missingInfo.push('이메일');
                            if (!kakao_account?.phone_number) missingInfo.push('전화번호');
                            if (!kakao_account?.name) missingInfo.push('실명');
 
                            fncInsertSocialLogin('KAKAO', id, properties?.nickname || '카카오사용자', properties?.profile_image || '');

                        },
                        fail: (error) => {
                            if (error.code === -401) {
                                alert('사용자 정보 접근 권한이 없습니다. 카카오 개발자 콘솔에서 동의항목을 확인해주세요.');
                            } else if (error.code === -2) {
                                alert('카카오 서버 오류입니다. 잠시 후 다시 시도해주세요.');
                            } else {
                                alert('카카오 사용자 정보를 가져오는데 실패했습니다.');
                            }
                        }
                    });
                },
                fail: (error) => {
                    if (error.error === 'KOE009') {
                        alert('카카오 앱 설정 오류입니다. 개발자 콘솔에서 도메인 설정을 확인해주세요.');
                    } else if (error.error === 'KOE205') {
                        alert('카카오 앱 설정 오류입니다. 개발자 콘솔 설정을 확인해주세요.');
                    } else if (error.error === 'timeout') {
                        alert('로그인 시간이 초과되었습니다. 다시 시도해주세요.');
                    } else if (error.error !== 'cancelled') {
                        alert('카카오 로그인에 실패했습니다.');
                    }
                }
            });
        } catch (error) {
            alert('카카오 로그인에 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    function fncInsertSocialLogin(acaCode, id, nickname, profile_image) {
            fnc.sendAxios('/socialLoginRoutes/insert/socialLogin', { acaCode, id, nickname, profile_image, isSocialLogin: 'Y' }, (res) => {
                if (res.success) {
                    console.log(res);
                    fncSelectSocialLogin(id);
                } else {
                alert('저장에 실패했습니다.');
                console.log(res);
                }
            });
        
        }
    
        function fncSelectSocialLogin(id) {
            fnc.sendAxios('/socialLoginRoutes/select/socialLogin', { id }, (res) => {
                if (res && res.length > 0) {
                    dispatch(setUserInfo2({
                        acaCode: res[0].acaCode || '',
                        nickname: res[0].nickname || '',
                        email: res[0].email || '',
                        id: res[0].id || '',
                        id2: res[0].id2 || '',//naver id 등 social login id 닉네임 아이디 임
                        profile_image: res[0].profile_image || '',
                        uid: res[0].uid || '' // firebase uid
                    }));
    
                    console.log(res, 'userinfo2 res');
                    dispatch(setIsLoggedIn(true));
                    navigate('/menu');
                } else {
                    alert('정보가 올바르지 않습니다.')
                    console.log(res,"속성이 obj 내에 없습니다.");
                }
            });
        }


    //=========================================================

    return (
        <button 
            className="social-btn kakao-btn" 
            onClick={handleKakaoLogin}
            disabled={loading}
        >
            <FaComments className="social-icon" />
            <span>카카오로 로그인</span>
        </button>
    );
}

export default KakaoLogin;